<template>
  <div>
    <el-row>
      <el-col :sm="4" :lg="4" :md="4" :xs="4">
        <p>Process</p>
      </el-col>
      <el-col :lg="20">
        <span style="float: right; padding-right: 20px; padding-top: 15px; padding-bottom: 10px"><a style="color: #0a8700" @click="addNew(true)"><i class="fas fa-plus"/> New</a></span>
      </el-col>
    </el-row>
    <hr>
    <el-row>
      <el-col>
        <el-table
          :data="data"
          stripe
          style="width: 100%">
          <el-table-column
            prop="name"
            label="Name"
            width="250"/>
          <el-table-column
            prop="clause.name"
            label="Clause"
            width="180"/>
          <el-table-column
            prop="owner[0].department.fullname"
            label="Owner"
            width="250"/>
          <el-table-column
            label="Action"
          >
            <template slot-scope="scope">
              <el-button type="warning" size="small" @click="edit(scope.row)"> edit</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <div style="text-align: center; padding-bottom: 20px" >
          <el-pagination :page-size="meta.per_page" :pager-count="11" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll()"/>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="titleDialog"
      width="30%"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" class="demo-ruleForm">
        <el-form-item label="Name" prop="name">
          <el-input v-model="form.name"/>
        </el-form-item>
        <el-form-item label="Clause" prop="clause_id">
          <el-select v-model="form.clause_id" placeholder="please select category">
            <el-option v-for="data in clauses" :key="data.key" :label="data.name" :value="data.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="Process Owner" prop="po_department">
          <el-select v-model="form.po_department" :remote-method="getDepartments" :remote="true" filterable clearable multiple placeholder="Select process owner">
            <el-option v-for="department in departments" :key="department.id" :value="department.id" :label="department.newname ? department.newname : department.fullname">{{ department.newname ? department.newname : department.fullname }}</el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="save('form')">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { QMSClause, QMSProcess } from '../../../api/qms'
import { Notification } from 'element-ui'
import { Department } from '../../../api/department'
export default {
  name: 'Process',
  data() {
    return {
      data: [],
      selected: {},
      dialogVisible: false,
      titleDialog: 'New Clause',
      clauses: [],
      departments: [],
      meta: {
        per_page: 12
      },
      form: {
        clause_id: null,
        name: '',
        desc: '',
        po_department: []
      },
      rules: {
        name: [
          { required: true, message: 'Please input Clause name', trigger: 'blur' },
          { min: 3, message: 'Length should be 3 ', trigger: 'blur' }
        ],
        clause_id: [
          { required: true, message: 'Please select category', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getAll()
    this.getClause()
  },
  methods: {
    getAll() {
      QMSProcess({ page: this.meta.page }, 'get').then(res => {
        console.log(res.data)
        this.data = res.data.process
        this.meta = res.data.meta
      }).catch()
    },
    getClause() {
      QMSClause({ per_page: 999 }, 'get').then(res => {
        this.clauses = res.data.clause
      }).catch()
    },
    getDepartments(query) {
      Department({ term: query }, 'all').then(res => {
        this.departments = res.data.departments
        this.departments.push(
          {
            acronym: 'ALL',
            fullname: 'All',
            head_id: 1,
            id: -1,
            newname: null,
            parent_id: 98
          }
        )
      }).catch()
    },
    save(form) {
      this.$refs[form].validate((valid) => {
        var message = 'Process is successfully created'
        if (valid) {
          var action = 'post'
          if (this.form.id) {
            action = 'put'
            message = 'Process is successfully updated'
          }
          QMSProcess(this.form, action).then(res => {
            Notification.success({
              title: 'Success',
              message: message,
              duration: 4 * 1000
            })
            this.getAll()
            this.dialogVisible = false
          }).catch()
        }
      })
    },
    addNew() {
      this.titleDialog = 'New Process'
      this.selected = {}
      this.form = {
        clause_id: null,
        name: '',
        desc: ''
      }
      this.dialogVisible = true
    },
    edit(row) {
      this.titleDialog = 'Edit Process'
      this.selected = row
      this.form = this.selected
      console.log(this.form)
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>

</style>
